import type { Side, WhistResult } from './play.js';

/** Short whist is a game to 5 points (the default), long whist to 10. */
export type WhistLength = 'short' | 'long';
export const WHIST_TARGET: Readonly<Record<WhistLength, number>> = { short: 5, long: 10 };
export const DEFAULT_WHIST_LENGTH: WhistLength = 'short';

/** Points add up across deals until one side reaches the target. */
export type WhistScore = Readonly<Record<Side, number>>;
export const NEW_WHIST_SCORE: WhistScore = { NS: 0, EW: 0 };

/** Add a finished deal's points to the side that won it. */
export function addDeal(score: WhistScore, result: WhistResult): WhistScore {
  return { ...score, [result.winningSide]: score[result.winningSide] + result.points };
}

/** The side that has reached the target, or null while the game goes on. */
export function gameWinner(score: WhistScore, length: WhistLength = DEFAULT_WHIST_LENGTH): Side | null {
  const target = WHIST_TARGET[length];
  const ns = score.NS >= target;
  const ew = score.EW >= target;
  if (ns && ew) return score.NS >= score.EW ? 'NS' : 'EW'; // cannot happen with one winner per deal; kept total
  return ns ? 'NS' : ew ? 'EW' : null;
}
